/**
 * Token Verification Controller
 */
class TokenSmsController {
    constructor(recoveryPasswordService, $scope, $uibModal, $state) {
        'ngInject';

        //Exposing globals to another methods
        this.recoveryPasswordService = recoveryPasswordService;
        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.$state = $state;
        this.loading = false;
        this.mostraOpcoesEnvioNovoCodigo = false;
        this.labelTipoEnvio = 'SMS';
        this.token = "";
        this.contador();
        this.$scope.iniciaContagemTempo();
    }

    contador(){
        function startTimer() {
            var duracao =  30;
            var tempo = duracao, minutos, segundos;
            var intervalo = setInterval(function () {
                minutos = parseInt(tempo / 60, 10);
                segundos = parseInt(tempo % 60, 10);
                minutos = minutos < 10 ? "0" + minutos : minutes;
                segundos = segundos < 10 ? "0" + segundos : segundos;
                document.getElementById('#contador').innerHTML = " em: " + minutos + ":" + segundos;
                if (--tempo < 0) {
                    tempo = duracao;
                }
                if(tempo === 0){
                    document.getElementById('#contador').innerHTML = "";
                    document.getElementById('#btnNovoCodigo').setAttribute('class', 'btnNovoCodigo');
                    document.getElementById('#btnNovoCodigo').removeAttribute('disabled');
                    clearInterval(intervalo);
                }
            }, 1000);
        }
        window.onload = function () {
            document.getElementById('#btnNovoCodigo').setAttribute('class', 'btnNovoCodigo btnNovoCodigoDisabled');
            startTimer();
        };

        this.$scope.iniciaContagemTempo = function () {
            document.getElementById('#btnNovoCodigo').setAttribute('class', 'btnNovoCodigo btnNovoCodigoDisabled');
            startTimer();
        }

        this.$scope.resetContador = function () {
            document.getElementById('#btnNovoCodigo').setAttribute('disabled', '');
            document.getElementById('#btnNovoCodigo').setAttribute('class', 'btnNovoCodigo btnNovoCodigoDisabled');
            startTimer();
        }
    }

    exibeOpcoesEnvioNovoCodigo(){
        this.mostraOpcoesEnvioNovoCodigo = !this.mostraOpcoesEnvioNovoCodigo;
    }

    async sendNewToken(tipoEnvio){
        this.loadingNewCode = true;
        let processId = sessionStorage.getItem("idProcesso");

        this.labelTipoEnvio = tipoEnvio;
        let result;
        if(tipoEnvio === 'SMS'){
            result = await this.recoveryPasswordService.sendNewSmsToken(processId).catch(e => result = e);
        } else {
            result = await this.recoveryPasswordService.sendNewWhatsAppToken(processId).catch(e => result = e);
        }

        if(result.status === 200){
            this.newTokenNotification(tipoEnvio);
        } else {
            this.showErrorModal();
        }
        this.loadingNewCode = false;
        this.$scope.$apply();
    }

    async confirmVerificationToken() {
        if (this.$scope.form.$invalid) return;

        this.loading = true;

        let result;
        result = await this.recoveryPasswordService.confirmSmsToken(this.token).catch(e => result = e);

        if (result.status === 200) {
            result = await this.recoveryPasswordService.retrieveSecurityQuestions().catch(e => result = e);
            if (result.status === 200) {
                this.showValidTokenModal(result.data);
            } else {
                this.showInvalidTokenModal(result.status);
            }
        }

        else if ([400, 401, 403].contains(result.status))
            this.showInvalidTokenModal(result.status);

        this.loading = false;
        this.$scope.$apply();
    }

    /**
     * 200 - new token notification
     */
    newTokenNotification(tipoEnvio) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'newTokenNotification.modal.html',
            controllerAs: '$ctrl',
            size: 'sm',
            controller: ($scope) => {
                "ngInject";
                let $ctrl = $scope.$ctrl;

                $ctrl.isEnvioPorSms = tipoEnvio === "SMS";
                $ctrl.ok = () => {
                    modalInstance.close();
                    this.mostraOpcoesEnvioNovoCodigo = !this.mostraOpcoesEnvioNovoCodigo;
                    this.$scope.resetContador();
                };
            }
        });
    };

    /**
     * 200 - Process Started Notification Modal
     */
    showValidTokenModal(securityQuestions) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'tokenValidNotification.modal.html',
            controllerAs: '$ctrl',
            size: 'sm',
            controller: ($scope) => {
                "ngInject";
                let $ctrl = $scope.$ctrl;

                $ctrl.ok = () => {
                    modalInstance.close();
                };
            }
        });
        modalInstance.result.then(() => {
            this.$state.go('question', {securityQuestions: securityQuestions});
        })
    };

    /**
     * 40X - Error Notification Modal
     */
    showInvalidTokenModal(code) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'invalidTokenNotification.modal.html',
            controllerAs: '$ctrl',
            size: 'sm',
            controller: ($scope, code) => {
                "ngInject";
                let $ctrl = $scope.$ctrl;

                $ctrl.code = code;
                $ctrl.ok = () => {
                    modalInstance.close();
                };
            },
            resolve: {
                code: () => code
            }
        });

        modalInstance.result.then(() => {
            if (code > 400)
                this.$state.go("login")
        }, () => {
            if (code > 403)
                this.$state.go("login")
        });
    };

    /**
     * Error Notification Modal
     */
    showErrorModal() {
        let modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'errorNotificationModal.modal.html',
            controllerAs: '$ctrl',
            size: 'sm',
            controller: ($scope) => {
                "ngInject";
                let $ctrl = $scope.$ctrl;

                $ctrl.ok = () => {
                    modalInstance.close();
                    this.mostraOpcoesEnvioNovoCodigo = !this.mostraOpcoesEnvioNovoCodigo;
                    this.$scope.resetContador();
                };
            },
        });
    };
}

export default TokenSmsController;


// WEBPACK FOOTER //
// ./src/app/components/views/tokenSms/tokenSms.controller.js